import React from "react";

export default function SideNavTitle(props) {
  return (
    <div className="section-title-one sidenav small">
      <h1 className="text-base border-b border-dark-secondary pb-2 mb-2 text-dark-secondary">
        {props.title}
      </h1>
    </div>
  );
}
